// Flujos de recepción definidos como JSON
export const receptionFlows = [
  {
    key: 'recepcion-pedidos',
    label: 'Recepción de Pedidos',
    description: 'Recepción guiada de productos contra orden de compra o pedido.'
  },
  {
    key: 'palletizado',
    label: 'Palletizado',
    description: 'Agrupa productos en pallets para optimizar el almacenamiento y transporte.'
  },
  // {
  //   key: 'recepcion-sin-pedido',
  //   label: 'Recepción sin Pedido',
  //   description: 'Recepción de productos sin orden previa.'
  // },
  // {
  //   key: 'recepcion-muestreo',
  //   label: 'Recepción con Muestreo',
  //   description: 'Recepción con control de calidad por muestreo.'
  // },
  // {
  //   key: 'recepcion-cuarentena',
  //   label: 'Recepción a Cuarentena',
  //   description: 'Recepción de productos que deben pasar a cuarentena.'
  // },
  // {
  //   key: 'recepcion-devolucion',
  //   label: 'Recepción de Devoluciones',
  //   description: 'Recepción de productos devueltos por clientes o proveedores.'
  // }
  
];

export const receptionFlowSchemas = {
  'recepcion-pedidos': {
    name: 'Recepción de Pedidos',
    steps: [
      { type: 'scan-orden', label: 'Escanea el número de pedido', field: 'pedido', placeholder: 'Escanea o ingresa el pedido', validation: { required: true } },
      { type: 'resumen-orden', label: 'Resumen de la orden', field: 'resumen_orden' },
      { type: 'scan', label: 'Escanea el SKU', field: 'sku', placeholder: 'Escanea o ingresa el SKU', validation: { required: true } },
      { type: 'input', label: 'Cantidad recibida', field: 'cantidad', inputType: 'number', placeholder: 'Ingresa la cantidad', validation: { required: true, min: 1 } },
      { type: 'scan', label: 'Escanea el área de staging', field: 'stagingArea', placeholder: 'Escanea o ingresa el área de staging', validation: { required: true } }
    ]
  },
  
  'palletizado': {
    name: 'Palletizado',
    steps: [
      { type: 'scan', label: 'Escanea área de staging', field: 'staging', placeholder: 'Escanea o ingresa el área de staging', validation: { required: true } },
      { type: 'scan-multiple', label: 'Escanea productos para agregar al pallet', field: 'productos', allowUndo: true, placeholder: 'Escanea o ingresa los productos', validation: { required: true } },
      { type: 'summary', label: 'Revisión del pallet', field: 'resumen', editable: true, placeholder: 'Revisa el resumen del pallet' },
      { type: 'confirm', label: '¿Confirmar paletizado y generar etiqueta?', field: 'confirmacion', placeholder: 'Confirma el paletizado' },
      { type: 'generate-label', label: 'Etiqueta generada', field: 'palletLabel', allowReprint: true, placeholder: 'Etiqueta generada para el pallet' }
    ]
  },
  'recepcion-sin-pedido': {
    name: 'Recepción sin Pedido',
    steps: [
      { type: 'scan-multiple-sku', label: 'Escanea productos (Código de Barras UPC/EAN)', field: 'productos', placeholder: 'Escanea o ingresa el código de barras (UPC/EAN)', validation: { required: true } },
      { type: 'scan', label: 'Ubicación destino', field: 'ubicacion', placeholder: 'Escanea o ingresa la ubicación', validation: { required: true } },
      { type: 'confirm', label: 'Confirma los datos', summaryFields: ['productos', 'ubicacion'] }
    ]
  },
  'recepcion-muestreo': {
    name: 'Recepción con Muestreo',
    steps: [
      { type: 'scan', label: 'Escanea el número de lote', field: 'lote', placeholder: 'Escanea o ingresa el lote', validation: { required: true } },
      { type: 'input', label: 'Cantidad total recibida', field: 'cantidad_total', inputType: 'number', placeholder: 'Ingresa la cantidad total', validation: { required: true, min: 1 } },
      { type: 'input', label: 'Cantidad muestreada', field: 'cantidad_muestreo', inputType: 'number', placeholder: 'Ingresa la cantidad muestreada', validation: { required: true, min: 1 } },
      { type: 'input', label: 'Resultado de muestreo', field: 'resultado', placeholder: 'Aprobado/Rechazado', validation: { required: true } },
      { type: 'scan', label: 'Ubicación destino', field: 'ubicacion', placeholder: 'Escanea o ingresa la ubicación', validation: { required: true } },
      { type: 'confirm', label: 'Confirma los datos', summaryFields: ['lote', 'cantidad_total', 'cantidad_muestreo', 'resultado', 'ubicacion'] }
    ]
  },
  'recepcion-cuarentena': {
    name: 'Recepción a Cuarentena',
    steps: [
      { type: 'scan', label: 'Escanea el SKU', field: 'sku', placeholder: 'Escanea o ingresa el SKU', validation: { required: true } },
      { type: 'input', label: 'Cantidad recibida', field: 'cantidad', inputType: 'number', placeholder: 'Ingresa la cantidad', validation: { required: true, min: 1 } },
      { type: 'scan', label: 'Ubicación de cuarentena', field: 'ubicacion', placeholder: 'Escanea o ingresa la ubicación de cuarentena', validation: { required: true } },
      { type: 'confirm', label: 'Confirma los datos', summaryFields: ['sku', 'cantidad', 'ubicacion'] }
    ]
  },
  'recepcion-devolucion': {
    name: 'Recepción de Devoluciones',
    steps: [
      { type: 'scan', label: 'Escanea el número de devolución', field: 'devolucion', placeholder: 'Escanea o ingresa el número de devolución', validation: { required: true } },
      { type: 'scan', label: 'Escanea el SKU', field: 'sku', placeholder: 'Escanea o ingresa el SKU', validation: { required: true } },
      { type: 'input', label: 'Cantidad devuelta', field: 'cantidad', inputType: 'number', placeholder: 'Ingresa la cantidad', validation: { required: true, min: 1 } },
      { type: 'scan', label: 'Ubicación destino', field: 'ubicacion', placeholder: 'Escanea o ingresa la ubicación', validation: { required: true } },
      { type: 'confirm', label: 'Confirma los datos', summaryFields: ['devolucion', 'sku', 'cantidad', 'ubicacion'] }
    ]
  }
};
